/*Filter returns true if error message should be filtered*/
const sentryFilter = (event, hint) => {
  //check target for scripts known for throwing noisy errors

  if (hint) {
    // Recaptcha throws "Timeout" - a rejection with a primitive value
    if (hint.originalException === "Timeout") {
      console.log("filtering error on Timeout", event, hint);
      return true;
    }
  }

  const errorTarget = hint?.originalException?.target?.src;
  if (errorTarget) {
    if (errorTarget.includes("googletagmanager") || errorTarget.includes("recaptcha")) {
      console.log(`filtering external script '${errorTarget}' error`, event, hint);
      return true;
    }
  }
};

export default sentryFilter;
